module.exports = __webpack_public_path__ + "assets/play_broken.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/video/play_broken.svg
// module id = 450
// module chunks = 19